import { render, staticRenderFns } from "./BoundPropertySelector.vue?vue&type=template&id=88a907d4&lang=html&"
import script from "./BoundPropertySelector.vue?vue&type=script&lang=js&"
export * from "./BoundPropertySelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
